import React from "react";
import PropTypes from "prop-types";

import FormGroup from "shared-anpost-components/components/form/form_group/FormGroup";
import InputGroup from "shared-anpost-components/components/form/input_group/InputGroup";
import Select from "shared-anpost-components/components/form/select/Select";
import Pagination from "shared-anpost-components/components/form/pagination/Pagination";
import Loader from "shared-anpost-components/components/loader/Loader";

import ShopNoOrders from "./ShopNoOrders";
import ShopTransactionCard from "./ShopTransactionCard";
import { mapItemsPerPageSelect, mapStatusTagStyles, formatedPrice, formatedDate } from "./utils";
import { Box } from "../ui";

const ShopOrdersList = ({ error, currentPage, ordersPerPage, ordersPerPageChange, onPageChange, items, totalItems, isLoading }) => {
    const mapProductList = productList => {
        return {
            items: productList.map(product => product.productName).splice(0, 2),
            moreItemsCount: productList.length - 2 > 0 ? productList.length - 2 : 0
        };
    };

    if (isLoading) return <Loader local />;
    if (error) return null;
    if (items?.length === 0) return <ShopNoOrders />;
    return (
        <Box gap="16px">
            {items?.map(order => (
                <ShopTransactionCard
                    orderDate={formatedDate(order.orderDate)}
                    orderId={order.orderId}
                    productList={mapProductList(order.orderItems)}
                    tagStyle={mapStatusTagStyles(order.orderStatus)}
                    price={formatedPrice(order.orderTotal)}
                    status={order.orderStatus}
                    key={order.orderId}
                />
            ))}
            {totalItems > 10 && (
                <Box flexDirection={["column", "row"]} justifyContent={["", "space-between"]} gap="8px">
                    <FormGroup focused>
                        <InputGroup>
                            <Select
                                labelText="Orders per page"
                                focused
                                showLabel
                                id="ordersperpage"
                                type="number"
                                name="ordersperpage"
                                change={ordersPerPageChange}
                                defaultValue="Orders per page"
                                selectedValue="10"
                                options={mapItemsPerPageSelect()}
                                required
                            />
                        </InputGroup>
                    </FormGroup>
                    <Box alignItems="center" justifyContent="center">
                        <Pagination pageCount={totalItems} pageSize={ordersPerPage} pageChange={onPageChange} currentPage={currentPage} />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default ShopOrdersList;

ShopOrdersList.propTypes = {
    ordersPerPage: PropTypes.number,
    error: PropTypes.string,
    currentPage: PropTypes.number,
    ordersPerPageChange: PropTypes.func,
    onPageChange: PropTypes.func,
    items: PropTypes.array,
    totalItems: PropTypes.number,
    isLoading: PropTypes.bool
};
